import React from "react";
import { RydProject } from "../../../model/project";
import {
    RydBookmark,
    RydBookmarkSelection
} from "../../../model/bookmark";
import { useWorkspaceUIState } from "../../../stores/WorkspaceStore";
import {
    getLeftNearestGridPoint,
    NOTE_WIDTH,
    tickToPosition
} from "../../../render/renderUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";


export function RydBookmarkGlyph({
    project,
    bookmark,
    zoomFactor,
    onUpdate
}: {
    project: RydProject,
    bookmark: RydBookmark & RydBookmarkSelection
    zoomFactor: number,
    onUpdate: (b: RydBookmark) => void
}) {

    const [dragStartX, setDragStartX] = React.useState<number | undefined>();
    const workspaceUiState = useWorkspaceUIState();

    const glow = bookmark.selected ? {
        opacity: 1.0,
        // textShadow: `0 0 4px ${b.color}, 0 0 8px ${b.color}, 0 0 12px ${b.color}`,
        glow1: `0 0 16px ${bookmark.color}`,
        glow2: `0 0 24px ${bookmark.color}`,
        glow3: `0 0 32px ${bookmark.color}`,
    } : {};

    return (<button
        className="ryd-bookmark--timeline"
        style={{
            left: `calc(var(--piano-roll-header-width) + ${tickToPosition(NOTE_WIDTH, zoomFactor, bookmark.position)}px)`,
            color: bookmark.color,
            zIndex: bookmark.scope === 'loop' ? '9': '10',
            ...glow,
        }}
        draggable={true}
        onDragStart={(e) => setDragStartX(e.clientX)}
        onDragEnd={(e) => {
            if (dragStartX === undefined) return;
            const deltaX = e.clientX - dragStartX;
            const deltaTicks = Math.round((deltaX * zoomFactor) / NOTE_WIDTH);
            bookmark.position = Math.max(0, bookmark.position + deltaTicks);

            if (workspaceUiState.snapToGrid) {
                const gridRes = workspaceUiState.gridResolution;
                const ppq = project.getTrack(0)?.sequence.getPPQ() || 480;
                bookmark.position = getLeftNearestGridPoint(bookmark.position, ppq, zoomFactor, gridRes);
            }
            onUpdate(bookmark);
            setDragStartX(undefined);
        }}
    >

        <span style={{}}>
            {bookmark.scope === 'app'
                ? '■'
                : bookmark.scope === 'loop'
                    ? '●'
                    : <FontAwesomeIcon icon={faArrowDown} />}
        </span>
    </button>)
}